const pinEntryOptions = [
  {
    "key": "UNSPECIFIED",
    "text": "Unspecified"
  },
  {
    "key": "PIN_ENTRY_CAPABILITY",
    "text": "Pin entry capability"
  },
  {
    "key": "PIN_ENTRY_NO_CAPABILITY",
    "text": "Pin entry no capability"
  },
  {
    "key": "PIN_PAD_INOPERATIVE",
    "text": "Pin pad inoperative"
  },
  {
    "key": "PIN_VERIFIED_BY_TERMINAL",
    "text": "Pin verified by terminal"
  }
];

export default pinEntryOptions;





